import { pdfAPI } from "../api";

export default function FileUploader({ setText, setLoading }) {

  // 🛡️ safe wrapper (agar setLoading na ho to ignore)
  const safeSetLoading = (value) => {
    if (typeof setLoading === "function") {
      setLoading(value);
    }
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/png",
      "image/jpeg",
      "image/jpg",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Unsupported file type");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      safeSetLoading(true);

      const response = await pdfAPI.post(
        "/extract-questions",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const { questions = [] } = response.data;

      if (!questions.length) {
        alert("No questions extracted from file");
        return;
      }

      // 🧠 convert questions → text
      const text = questions
        .map((q, i) => {
          let block = `Q${i + 1}. ${q.question}\n`;

          if (q.options && Object.keys(q.options).length > 0) {
            Object.entries(q.options).forEach(([key, value]) => {
              block += `${key}) ${value}\n`;
            });
          }

          if (q.answer) {
            block += `Answer: ${q.answer}\n`;
          }

          return block + "\n";
        })
        .join("");

      setText(text);

    } catch (error) {
      console.error("PDF extraction error:", error);
      alert(
        error?.response?.data?.error ||
        "PDF extraction failed. Please try again."
      );
    } finally {
      safeSetLoading(false);
      e.target.value = ""; // reset input
    }
  };

  return (
    <div className="file-uploader">
      <input
        type="file"
        accept=".pdf,.docx,.png,.jpg,.jpeg"
        onChange={handleFile}
      />
    </div>
  );
}
